<template>
  <AppAutocomplete
    v-model="country"
    :items="items"
    :placeholder="$tt('country')"
    :rules="[required]"
    append-inner-icon="mdi:globe"
  />
</template>

<script lang="ts">
let ALL_COUNTRIES: SelectItem<CountryIso>[] = [];
</script>

<script setup lang="ts">
import { objectKeys } from '~/helpers/general';
import type { CountryIso, SelectItem } from '~/types';

const country = defineModel<CountryIso>({ required: true });
const props = defineProps<{
  countries?: CountryIso[];
}>();

const { required } = useValidation();

if (!ALL_COUNTRIES.length) populateCountryList();

const items = props.countries ? ALL_COUNTRIES.filter(item => props.countries!.includes(item.value)) : ALL_COUNTRIES;
validateModelCountry();

function populateCountryList() {
  const { countries, tCountry } = useLocalization();
  const countryKeys = objectKeys(countries.value);
  ALL_COUNTRIES = countryKeys.map(key => ({ value: key, title: tCountry(key) }));
}

function validateModelCountry() {
  if (!items.some(item => item.value == country.value)) {
    console.warn(`"${country.value}" not found in the list of countries. Setting to first country instead.`);
    country.value = items[0].value;
  }
}
</script>